import emptyLogo from '@assets/images/common/notification_empty_state.svg';
import { useTranslation } from 'react-i18next';

function NotificationsCenterListEmpty() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center pb-8 pt-2">
      <p className="typo typo--empty">{t('notification.empty')}</p>
      <img
        alt="Empty notifications"
        className="notifications-popover__empty--image"
        src={emptyLogo}
      />
    </div>
  );
}

export { NotificationsCenterListEmpty };
